import { Alert, Typography } from "antd";
import dayjs from "dayjs";
import React from "react";

import { DATE_FORMAT_DISPLAY } from "@/constant";
import { useAuthStore } from "@/stores/authStore";

import styles from "./RedeemPledgeDetailsForCustomerConsent.module.css";

interface Props {
  details: any;
}
const InfoRow = ({ label, value }: any): JSX.Element => (
  <div className={styles.labelValueWrapper}>
    <div className={styles.label}>{label}</div>
    <div className={styles.value}>{value || "-"}</div>
  </div>
);
export const RedeemPledgeDetailsForCustomerConsent: React.FC<Props> = ({ details }) => {
  const currency = useAuthStore((state) => state.currency);

  return (
    <div>
      {details?.map((item: any) => (
        <div className="px-6 py-4 bg-[#f7f8fc] border border-[#0082CA] rounded-[5px]  overflow-hidden m-3 flex flex-col gap-2 w-full">
          <Typography.Text type="secondary" className="text-right text-sm lg:text-xs text-gray-500">
            Consent Generated At: {dayjs(item.consent_generated_at).format("DD/MM/YYYY hh:mm:ss A")}
          </Typography.Text>
          {dayjs(item.consent_generated_at).startOf("day").isBefore(dayjs(), "day") && (
            <Alert
              type="warning"
              showIcon
              message="The consent was not completed previously in the past."
            />
          )}
          <div className={styles.infoRowContainer}>
            <InfoRow label="Pledge Alpha Code:" value={<span>{item?.ticket_alpha_code}</span>} />
            <InfoRow
              label={`Pledge Amount (${currency}):`}
              value={<span>{item?.offered_pledge_amount ? item?.offered_pledge_amount : "-"}</span>}
            />
            <InfoRow
              label="Create Date:"
              value={item?.pledge_date ? dayjs(item?.pledge_date).format(DATE_FORMAT_DISPLAY) : "-"}
            />
            <InfoRow
              label="Due Date:"
              value={
                item?.pledge_expiry_date
                  ? dayjs(item?.pledge_expiry_date).format(DATE_FORMAT_DISPLAY)
                  : "-"
              }
            />
          </div>
        </div>
      ))}
    </div>
  );
};
